import { useMutation } from '@tanstack/react-query';
import { z } from 'zod';
import { api } from '@/lib/api-client';
import { MutationConfig } from '@/lib/tanstack-query';
import { MobileNumberSchema } from '@/validators/shared/utility/mobile-number.schema';
import { NameSchema } from '@/validators/shared/utility/name.schema';

export const RegisterInputSchema = z.object({
  firstName: NameSchema,
  lastName: NameSchema,
  email: z.string().email('Ogiltig e-post'),
  mobileNumber: MobileNumberSchema,
});

export type RegisterInput = z.infer<typeof RegisterInputSchema>;

export type RegisterResult = {
  authenticationId: string;
};

export const register = async ({ data }: { data: RegisterInput }): Promise<RegisterResult> => {
  return (await api.post(`/users/register`, data)).data;
};

type UseRegisterOptions = {
  mutationConfig?: MutationConfig<typeof register>;
};

export const useRegister = ({ mutationConfig }: UseRegisterOptions = {}) => {
  const { onSuccess, ...restConfig } = mutationConfig || {};

  return useMutation({
    onSuccess: (...args) => {
      // queryClient.refetchQueries({});
      onSuccess?.(...args);
    },
    ...restConfig,
    mutationFn: register,
  });
};
